import { render, staticRenderFns } from "./TemplateDocuments.vue?vue&type=template&id=88843706&"
import script from "./TemplateDocuments.vue?vue&type=script&lang=js&"
export * from "./TemplateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports